import React from 'react'
import cx from 'classnames'
import { Form, Input as AntdInput } from 'antd'
import { InputProps } from 'antd/lib/input'

import useTranslation from 'hooks/useTranslation'

import styles from './Input.module.scss'

import { maskPhoneNumber } from 'utils/form'

import { COUNTRY } from 'constants/config'

type Props = {
  className?: string
  label?: React.ReactNode
  name?: string // made optional for noFormItem use
  password?: boolean
  required?: boolean
  mobileNumber?: boolean
  customRules?: any
  noFormItem?: boolean
}

const Input = (props: Props & InputProps) => {
  const {
    className,
    label,
    name,
    password,
    required,
    mobileNumber,
    customRules,
    noFormItem,
    ...inputProps
  } = props
  const InputElement = password ? AntdInput.Password : AntdInput
  const cn = cx(styles.input, inputProps.disabled && styles.disabled, className)
  const { t, copy } = useTranslation()

  const handleChange = (str: string) => {
    const val = mobileNumber ? maskPhoneNumber(str) : str
    return val
  }

  if (noFormItem) {
    return <InputElement {...inputProps} className={cn} />
  }

  return (
    <Form.Item
      className={cn}
      name={name}
      label={label}
      rules={
        required
          ? [
              { required: true, message: t(copy.Inputs.Errors.required) },
              mobileNumber && COUNTRY === 'PH'
                ? {
                    min: 12,
                    message: t(copy.Inputs.Errors.phoneNumberTooShort),
                  }
                : {},
              mobileNumber && COUNTRY === 'ID'
                ? {
                    min: 11,
                    message: t(copy.Inputs.Errors.phoneNumberTooShort),
                  }
                : {},
              customRules && customRules.pattern
                ? { pattern: customRules.pattern, message: customRules.message }
                : {},
            ]
          : undefined
      }
      getValueFromEvent={(e) => handleChange(e.target.value)}
    >
      <InputElement {...inputProps} />
    </Form.Item>
  )
}

export default Input
